var _g, _circle, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_54871_1239)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.7051,
    r: 17.5,
    fill: "#0071FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 32.5,
    fill: "#0071FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54871_1239)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54871_1239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 31,
    width: 41,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0006 31H31.0006V71H71.0006V31Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54871_1239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6154 48.017L61.3925 47.4006C62.9041 46.1862 63.7676 44.3906 63.7618 42.4745C63.7557 40.5552 62.8905 38.7709 61.3878 37.5791C60.0757 36.5383 58.4366 36.071 56.7729 36.2628C55.1092 36.4548 53.6198 37.2833 52.5789 38.5954C52.1944 39.0802 51.6191 39.3582 51.0005 39.3582C50.382 39.3582 49.8065 39.0802 49.4186 38.591C48.2085 37.0843 46.4211 36.2215 44.5119 36.2215C44.5053 36.2215 44.4988 36.2215 44.4924 36.2215C42.5732 36.2275 40.7889 37.0927 39.597 38.5955C38.5562 39.9077 38.0888 41.5467 38.2807 43.2105C38.4727 44.8743 39.3011 46.3637 40.6134 47.4046L41.386 48.0172C41.9961 48.501 42.381 49.1934 42.4703 49.9669C42.5595 50.7405 42.3421 51.5023 41.8585 52.1123C40.6163 53.678 40.6163 55.8653 41.8584 57.4314C42.5688 58.3271 43.5854 58.8925 44.7211 59.0237C45.8569 59.1541 46.9754 58.8358 47.8712 58.1252C49.7137 56.6637 52.2877 56.6637 54.1302 58.125C54.9132 58.7463 55.8512 59.0568 56.7896 59.0568C57.7277 59.0567 58.6663 58.7462 59.4493 58.1252C61.2982 56.6587 61.6094 53.9614 60.1429 52.1126C59.1442 50.8529 59.3561 49.0159 60.6154 48.017ZM59.4413 46.5367C57.3656 48.1828 57.0163 51.2107 58.6625 53.2862C59.4816 54.319 59.3078 55.8255 58.2752 56.6446C57.4001 57.3385 56.1785 57.3385 55.3042 56.6446C54.0371 55.6396 52.5191 55.4 51.0004 55.4C49.4822 55.4 47.9637 55.6398 46.6969 56.6446C46.1966 57.0411 45.5725 57.2195 44.9375 57.1463C44.3032 57.0731 43.7353 56.7574 43.3386 56.2569C42.6448 55.3824 42.6448 54.1607 43.3386 53.2862C44.136 52.2809 44.4942 51.025 44.3473 49.7502C44.2001 48.4753 43.5654 47.3339 42.56 46.5365L41.7873 45.9239C39.8949 44.4229 39.5762 41.6619 41.0773 39.7695C41.91 38.7195 43.1569 38.115 44.4982 38.1108C44.5027 38.1108 44.5071 38.1108 44.5116 38.1108C45.845 38.1108 47.0961 38.7166 47.9417 39.7694C48.6866 40.7086 49.8015 41.2474 51.0004 41.2474C52.1993 41.2474 53.3141 40.7088 54.0591 39.7694C54.7862 38.8527 55.8269 38.2739 56.9894 38.1397C58.1521 38.0055 59.2969 38.3321 60.2137 39.0593C61.2635 39.8919 61.8681 41.1389 61.8722 42.4802C61.8764 43.8186 61.2703 45.0752 60.2136 45.9239L59.4413 46.5367Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0017798
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0403 49.1507C67.8076 49.1507 67.5914 49.0352 67.4619 48.8418C66.8101 47.8675 65.722 47.2857 64.551 47.2857C62.6203 47.2857 61.0494 48.8564 61.0494 50.7872C61.0494 51.9919 61.6572 53.0973 62.6754 53.7441C62.9986 53.9494 63.1994 54.3155 63.1994 54.6995V64.4206C63.1994 65.1698 63.809 65.7795 64.5584 65.7795H66.6936C67.4429 65.7795 68.0525 65.1698 68.0525 64.4206V55.0709C69.679 55.0642 71.0003 53.739 71.0003 52.1108C71.0004 50.4786 69.6725 49.1507 68.0403 49.1507ZM68.0403 53.1814C67.5389 53.1814 67.0674 53.3767 66.7127 53.7314C66.3584 54.086 66.1632 54.5573 66.1632 55.0586V63.8899H65.0889V54.6994C65.0889 53.6594 64.5654 52.706 63.6885 52.1491C63.2192 51.851 62.939 51.3419 62.939 50.7871C62.939 49.8982 63.6621 49.175 64.5512 49.175C65.0901 49.175 65.5913 49.4432 65.8918 49.8921C66.3725 50.6108 67.1757 51.0399 68.0406 51.0399C68.6309 51.0399 69.1112 51.5202 69.1112 52.1105C69.1112 52.7009 68.6306 53.1814 68.0403 53.1814Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0017798
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45 47.2857C36.279 47.2857 35.1908 47.8674 34.5391 48.8417C34.4098 49.0352 34.1934 49.1507 33.9606 49.1507C32.3284 49.1507 31.0005 50.4786 31.0005 52.1108C31.0005 53.739 32.3218 55.0642 33.9484 55.0709V64.4206C33.9484 65.1698 34.558 65.7795 35.3072 65.7795H37.4425C38.1917 65.7795 38.8014 65.1698 38.8014 64.4206V54.6995C38.8014 54.3155 39.0023 53.9494 39.3257 53.744C40.3438 53.0972 40.9514 51.9919 40.9514 50.7872C40.9514 48.8563 39.3807 47.2857 37.45 47.2857ZM38.3128 52.1491C37.4357 52.7059 36.9121 53.6594 36.9121 54.6994V63.8899H35.8379V55.0586C35.8379 54.5572 35.6427 54.0857 35.2882 53.7311C34.9336 53.3767 34.4622 53.1814 33.9607 53.1814C33.3703 53.1814 32.89 52.7011 32.89 52.1108C32.89 51.5204 33.3703 51.0401 33.9607 51.0401C34.8253 51.0401 35.6286 50.6111 36.1096 49.8923C36.4101 49.4434 36.9112 49.1752 37.4502 49.1752C38.3391 49.1752 39.0623 49.8984 39.0623 50.7873C39.062 51.3418 38.7817 51.851 38.3128 52.1491Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0017798
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9483 39.1616C43.0976 39.1616 41.5918 40.6673 41.5918 42.5181C41.5918 43.0399 42.0147 43.4628 42.5365 43.4628C43.0584 43.4628 43.4812 43.0399 43.4812 42.5181C43.4812 41.709 44.1394 41.051 44.9483 41.051C45.4701 41.051 45.893 40.6281 45.893 40.1063C45.893 39.5844 45.47 39.1616 44.9483 39.1616Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0017798
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54871_1239",
    x: 0,
    y: 0.205078,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_54871_1239"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54871_1239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(31 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHip);
export default __webpack_public_path__ + "static/media/hip.a091d8ed9d6c9fec2cc3b115d439b198.svg";
export { ForwardRef as ReactComponent };